import React from 'react';
import styles from './EventGalleryImageCard.module.css';
import { useTranslation } from 'react-i18next';

const EventGalleryImageCard = ({ image, onImageClick }) => {
  const { url, caption, is_featured, visibility, status } = image;
  const { t } = useTranslation('galleryImageCard');

  const blockImageSaveActions = (e) => {
    e.preventDefault();
  };

  const showLock =
    visibility !== 'public' || (visibility === 'public' && status !== 'approved');

  return (
    <div className={styles.card}>
      <div className={styles.thumbWrapper}>
        {is_featured && (
          <span className={styles.featuredBadge}>★</span>
        )}
        {showLock && (
          <span className={styles.lockBadge} title={t('lockTitle')}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          </span>
        )}
        <div className={styles.overlay} />
        <img
          src={url}
          alt={caption || 'memory'}
          className={styles.thumb}
          loading="lazy"
          draggable={false}
          onContextMenu={blockImageSaveActions}
          onDragStart={blockImageSaveActions}
          onClick={onImageClick}
        />
      </div>
      <div className={styles.meta}>
        {caption && <p className={styles.caption}>{caption}</p>}
      </div>
    </div>
  );
};

export default EventGalleryImageCard;
